import React from 'react';

export const ResultCount = (props) => {

    const start = props.total === 0 ? 0 : props.start;
    return (
        <span style={{fontWeight: "bold"}}>
            {start} - {props.end} von {props.total}
        </span>
    )
};

export default ResultCount;



// WEBPACK FOOTER //
// ./src/admin/components/List/ResultCount.js